import ipxStaticRuntime_3665aY4kq9C__noNGzMQO3AzXAcbskTjmvd5uTVxviTEs from '/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/node_modules/.pnpm/@nuxt+image@2.1.0_@types+node@26.2.0_magic-string@1.1.0_magicast@0.5.4_oxc-parser@0.143_368fc72636a0b47158ddd884f2c90e79/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"ipxStatic"} */
  provider: "ipxStatic",
  providers: {
      ['ipxStatic']: { setup: ipxStaticRuntime_3665aY4kq9C__noNGzMQO3AzXAcbskTjmvd5uTVxviTEs, defaults: {} }
  }
}
